export const styles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		paddingTop: '4px'
	},
	button_group: {
		display: 'flex'
	},
	buttons: {
		marginRight: '8px'
	},
	title: {
		fontWeight: 600,
		flexGrow: 1
	},
	content: {
		padding: '8px'
	},
	code_block: {
		padding: '8px',
		border: `1px solid primary.main`,
		backgroundColor: '#eaebec38'
	},
	successWrapper: {
		marginLeft: '35px',
		'@media(max-width: 500px)': {
			marginLeft: '15px'
		},
		'& span': {
			marginRight: '15px',
			whiteSpace: 'nowrap'
		},
		'& p': {
			marginTop: '10px'
		},
		'& .MuiInputBase-root': {
			border: '1px solid #cccccc',
			borderRadius: '4px',
			boxShadow: 'inset 0 1px 1px rgb(0 0 0 / 8%)',
			color: '#555555',
			height: '34px',
			padding: '10px',
			width: '100%',
			maxWidth: '400px'
		},
		'& .MuiInput-underline:before, & .Mui-focused.MuiInput-underline:after': {
			display: 'none'
		}
	},
	successContent: {
		display: 'flex',
		alignItems: 'center',
		'@media(max-width: 500px)': {
			flexDirection: 'column',
			alignItems: 'flex-start'
		}
	}
};
